// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Layout of this component:
 * +-------------------------------------+
 * | :host                               |
 * | +---------------------------------+ |
 * | | .main                           | |
 * | | +-----------------------------+ | |
 * | | | .main-label | .main-buttons | | |
 * | | +-----------------------------+ | |
 * | +---------------------------------+ |
 * | | .details                        | |
 * | +---------------------------------+ |
 * | | slot                            | |
 * | +---------------------------------+ |
 * +-------------------------------------+
 */

:host {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  justify-content: center;

  /* Without details, the tile's height should be 32px. */
  padding: calc(var(--space-2) - var(--border-width)) var(--space-2);
}

.main {
  display: flex;
  gap: var(--space-1);
  height: 16px;
}

.main-label {
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;

  & .d-data-type-icon:last-of-type {
    margin-right: 2px;
  }
}

.main-buttons {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: var(--space-1);
}

:host([disabled]) .remove {
  display: none;
}

.details {
  font-size: var(--small-font-size);

  &:empty {
    display: none;
  }
}

/*
 * We check the host not being empty, because atm we cannot check it for the slot itself:
 * https://github.com/w3c/csswg-drafts/issues/6867
 */

:host(:not(:empty)) .additional-details {
  display: block;
}

:host(.is-modified) .attribute-name {
  font-style: italic;
  padding-right: 2px; /* Required to not cut off some part of the italic characters which lean out of the container */
}

/* If locked, hide all buttons in the attribute tile except the info button.
 * If not locked, hide the lock-icon
 */

:host([locked]) .button:not(.d-attribute-tile--info-button),
:host(:not([locked])) .lock-icon {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/cadenza/ui/attribute-tile/attribute-tile.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,uDAAuD;EACvD,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,YAAY;;EAEZ;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;;EAEjC;IACE,aAAa;EACf;AACF;;AAEA;;;EAGE;;AACF;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB,EAAE,+FAA+F;AACrH;;AAEA;;EAEE;;AACF;;EAEE,aAAa;AACf","sourcesContent":["/*\n * Layout of this component:\n * +-------------------------------------+\n * | :host                               |\n * | +---------------------------------+ |\n * | | .main                           | |\n * | | +-----------------------------+ | |\n * | | | .main-label | .main-buttons | | |\n * | | +-----------------------------+ | |\n * | +---------------------------------+ |\n * | | .details                        | |\n * | +---------------------------------+ |\n * | | slot                            | |\n * | +---------------------------------+ |\n * +-------------------------------------+\n */\n\n:host {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  justify-content: center;\n\n  /* Without details, the tile's height should be 32px. */\n  padding: calc(var(--space-2) - var(--border-width)) var(--space-2);\n}\n\n.main {\n  display: flex;\n  gap: var(--space-1);\n  height: 16px;\n}\n\n.main-label {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n\n  & .d-data-type-icon:last-of-type {\n    margin-right: 2px;\n  }\n}\n\n.main-buttons {\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  gap: var(--space-1);\n}\n\n:host([disabled]) .remove {\n  display: none;\n}\n\n.details {\n  font-size: var(--small-font-size);\n\n  &:empty {\n    display: none;\n  }\n}\n\n/*\n * We check the host not being empty, because atm we cannot check it for the slot itself:\n * https://github.com/w3c/csswg-drafts/issues/6867\n */\n:host(:not(:empty)) .additional-details {\n  display: block;\n}\n\n:host(.is-modified) .attribute-name {\n  font-style: italic;\n  padding-right: 2px; /* Required to not cut off some part of the italic characters which lean out of the container */\n}\n\n/* If locked, hide all buttons in the attribute tile except the info button.\n * If not locked, hide the lock-icon\n */\n:host([locked]) .button:not(.d-attribute-tile--info-button),\n:host(:not([locked])) .lock-icon {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
